import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";
import { seo } from "../translations/seo";

export default function NotFound() {
  const { language } = useLanguage();
  const s = seo[language].notfound;
  return (
    <div className="min-h-screen bg-white font-jakarta flex flex-col">
      <Seo title={s.title} description={s.description} noindex />
      <Navbar />
      <main className="flex-1 pt-40 pb-24 max-w-xl mx-auto px-6 text-center" data-testid="not-found-page">
        <p className="font-outfit text-7xl font-bold gradient-text mb-4">404</p>
        <h1 className="font-outfit text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-testid="not-found-title">{s.heading}</h1>
        <p className="text-slate-500 mb-10">{s.text}</p>
        <Link
          to="/"
          className="gradient-bg text-white font-semibold px-6 py-3 rounded-full hover:opacity-90 transition-opacity inline-flex items-center gap-2"
          data-testid="not-found-home-link"
        >
          <ArrowLeft className="w-4 h-4" /> {s.back}
        </Link>
      </main>
      <Footer />
    </div>
  );
}
